var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRequestAccessQuotation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 356,
    height: 356,
    viewBox: "0 0 356 356",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1465_4941",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -1,
    y: -1,
    width: 358,
    height: 358
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -0.910156,
    y: 64.0234,
    width: 300,
    height: 300,
    rx: 7.8125,
    transform: "rotate(-12.5 -0.910156 64.0234)",
    fill: "url(#paint0_radial_1465_4941)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1465_4941)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 155.87,
    y: 163.914,
    width: 37.1094,
    height: 37.1094,
    rx: 7.61719,
    transform: "rotate(-12.5 155.87 163.914)",
    stroke: "#B5B5C2",
    strokeWidth: 0.390625
  }), /*#__PURE__*/React.createElement("rect", {
    x: 133.506,
    y: 149.648,
    width: 74.6094,
    height: 74.6094,
    rx: 7.61719,
    transform: "rotate(-12.5 133.506 149.648)",
    stroke: "#B5B5C2",
    strokeWidth: 0.390625
  }), /*#__PURE__*/React.createElement("rect", {
    x: 111.139,
    y: 135.406,
    width: 112.109,
    height: 112.109,
    rx: 7.61719,
    transform: "rotate(-12.5 111.139 135.406)",
    stroke: "#B5B5C2",
    strokeWidth: 0.390625
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88.7798,
    y: 121.156,
    width: 149.609,
    height: 149.609,
    rx: 7.61719,
    transform: "rotate(-12.5 88.7798 121.156)",
    stroke: "#B5B5C2",
    strokeWidth: 0.390625
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.4126,
    y: 106.914,
    width: 187.109,
    height: 187.109,
    rx: 7.61719,
    transform: "rotate(-12.5 66.4126 106.914)",
    stroke: "#B5B5C2",
    strokeWidth: 0.390625
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44.0533,
    y: 92.6718,
    width: 224.609,
    height: 224.609,
    rx: 7.61719,
    transform: "rotate(-12.5 44.0533 92.6718)",
    stroke: "#B5B5C2",
    strokeWidth: 0.390625
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.6861,
    y: 78.4218,
    width: 262.109,
    height: 262.109,
    rx: 7.61719,
    transform: "rotate(-12.5 21.6861 78.4218)",
    stroke: "#B5B5C2",
    strokeWidth: 0.390625
  }), /*#__PURE__*/React.createElement("rect", {
    x: -0.6772,
    y: 64.1718,
    width: 299.609,
    height: 299.609,
    rx: 7.61719,
    transform: "rotate(-12.5 -0.6772 64.1718)",
    stroke: "#B5B5C2",
    strokeWidth: 0.390625
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1465_4941)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 154.5,
    y: 154,
    width: 48,
    height: 48,
    rx: 9.30247,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154.965,
    y: 154.465,
    width: 47.0698,
    height: 47.0698,
    rx: 8.83735,
    stroke: "#EAECF0",
    strokeWidth: 0.930247,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.004 172H181.132C182.026 172.001 182.883 172.357 183.515 172.99C184.147 173.623 184.502 174.481 184.502 175.375V184.75C185.298 184.75 186.061 184.434 186.623 183.871C187.186 183.309 187.502 182.546 187.502 181.75V172.108C187.502 170.603 186.377 169.297 184.838 169.168C184.614 169.15 184.389 169.133 184.165 169.118C183.912 168.63 183.53 168.221 183.06 167.936C182.59 167.651 182.051 167.5 181.502 167.5H180.002C179.452 167.5 178.913 167.651 178.444 167.936C177.974 168.221 177.592 168.63 177.339 169.118C177.114 169.133 176.889 169.15 176.666 169.168C175.164 169.295 174.056 170.542 174.004 172ZM180.002 169C179.604 169 179.223 169.158 178.941 169.439C178.66 169.721 178.502 170.102 178.502 170.5H183.002C183.002 170.102 182.844 169.721 182.563 169.439C182.281 169.158 181.9 169 181.502 169H180.002Z",
    fill: "#011229"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M169.5 175.375C169.5 174.339 170.34 173.5 171.375 173.5H181.125C182.161 173.5 183 174.34 183 175.375V186.625C183 187.66 182.16 188.5 181.125 188.5H171.375C170.878 188.5 170.401 188.302 170.049 187.951C169.698 187.599 169.5 187.122 169.5 186.625V175.375ZM172.5 178C172.5 177.801 172.579 177.61 172.72 177.47C172.86 177.329 173.051 177.25 173.25 177.25H173.258C173.457 177.25 173.648 177.329 173.788 177.47C173.929 177.61 174.008 177.801 174.008 178V178.008C174.008 178.207 173.929 178.398 173.788 178.538C173.648 178.679 173.457 178.758 173.258 178.758H173.25C173.051 178.758 172.86 178.679 172.72 178.538C172.579 178.398 172.5 178.207 172.5 178.008V178ZM174.75 178C174.75 177.801 174.829 177.61 174.97 177.47C175.11 177.329 175.301 177.25 175.5 177.25H179.25C179.449 177.25 179.64 177.329 179.78 177.47C179.921 177.61 180 177.801 180 178C180 178.199 179.921 178.39 179.78 178.53C179.64 178.671 179.449 178.75 179.25 178.75H175.5C175.301 178.75 175.11 178.671 174.97 178.53C174.829 178.39 174.75 178.199 174.75 178ZM172.5 181C172.5 180.801 172.579 180.61 172.72 180.47C172.86 180.329 173.051 180.25 173.25 180.25H173.258C173.457 180.25 173.648 180.329 173.788 180.47C173.929 180.61 174.008 180.801 174.008 181V181.008C174.008 181.207 173.929 181.398 173.788 181.538C173.648 181.679 173.457 181.758 173.258 181.758H173.25C173.051 181.758 172.86 181.679 172.72 181.538C172.579 181.398 172.5 181.207 172.5 181.008V181ZM174.75 181C174.75 180.801 174.829 180.61 174.97 180.47C175.11 180.329 175.301 180.25 175.5 180.25H179.25C179.449 180.25 179.64 180.329 179.78 180.47C179.921 180.61 180 180.801 180 181C180 181.199 179.921 181.39 179.78 181.53C179.64 181.671 179.449 181.75 179.25 181.75H175.5C175.301 181.75 175.11 181.671 174.97 181.53C174.829 181.39 174.75 181.199 174.75 181ZM172.5 184C172.5 183.801 172.579 183.61 172.72 183.47C172.86 183.329 173.051 183.25 173.25 183.25H173.258C173.457 183.25 173.648 183.329 173.788 183.47C173.929 183.61 174.008 183.801 174.008 184V184.008C174.008 184.207 173.929 184.398 173.788 184.538C173.648 184.679 173.457 184.758 173.258 184.758H173.25C173.051 184.758 172.86 184.679 172.72 184.538C172.579 184.398 172.5 184.207 172.5 184.008V184ZM174.75 184C174.75 183.801 174.829 183.61 174.97 183.47C175.11 183.329 175.301 183.25 175.5 183.25H179.25C179.449 183.25 179.64 183.329 179.78 183.47C179.921 183.61 180 183.801 180 184C180 184.199 179.921 184.39 179.78 184.53C179.64 184.671 179.449 184.75 179.25 184.75H175.5C175.301 184.75 175.11 184.671 174.97 184.53C174.829 184.39 174.75 184.199 174.75 184Z",
    fill: "#011229"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M198.5 150C197.572 150 196.682 150.369 196.025 151.025C195.369 151.682 195 152.572 195 153.5V155.5C194.47 155.5 193.961 155.711 193.586 156.086C193.211 156.461 193 156.97 193 157.5V162C193 162.53 193.211 163.039 193.586 163.414C193.961 163.789 194.47 164 195 164H202C202.53 164 203.039 163.789 203.414 163.414C203.789 163.039 204 162.53 204 162V157.5C204 156.97 203.789 156.461 203.414 156.086C203.039 155.711 202.53 155.5 202 155.5V153.5C202 151.567 200.433 150 198.5 150ZM201 155.5V153.5C201 152.837 200.737 152.201 200.268 151.732C199.799 151.263 199.163 151 198.5 151C197.837 151 197.201 151.263 196.732 151.732C196.263 152.201 196 152.837 196 153.5V155.5H201Z",
    fill: "#C13434"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1465_4941",
    x: 152.64,
    y: 148.07,
    width: 55.721,
    height: 56.721,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.930247
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.930247
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1465_4941"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1465_4941",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1465_4941",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(149.09 214.023) rotate(90) scale(150 150)"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequestAccessQuotation);
export default __webpack_public_path__ + "static/media/request_access_quotation.7882dc3501274a91391adb04dfb5d5e1.svg";
export { ForwardRef as ReactComponent };